export default {
  setupKeyboardShortcutBlocking() {
    if (!document.body.classList.contains('block-search-shortcuts')) return
    if (this._installed) return
    this._installed = true

    document.addEventListener('keydown', (e) => {
      const key = e.key.toLowerCase()
      if (((e.metaKey || e.ctrlKey) && (key === 'f' || key === 'g')) || e.key === 'F3') {
        e.preventDefault()

        if (!e.repeat) {
          this._trackBlockedShortcut(e)
        }
      }
    }, { capture: true })
  },

  _trackBlockedShortcut(e) {
    const modifier = e.metaKey ? 'cmd+' : (e.ctrlKey ? 'ctrl+' : '')

    try {
      snowplow('trackStructEvent', {
        category: 'keyboard_shortcut_blocking',
        action: 'shortcut_blocked',
        label: `${modifier}${e.key.toLowerCase()}`,
        property: window.location.pathname
      })
    } catch {
      // Non-blocking
    }
  }
}
